import {MOMENT_DATE_FORMAT} from '@core/constants';
import moment from 'moment';

export class DateHelper {
  static readonly MY_DATE_FORMAT = {
    parse: {
      dateInput: [MOMENT_DATE_FORMAT, 'DD-MM-YYYY']
    },
    display: {
      dateInput: MOMENT_DATE_FORMAT,
      monthYearLabel: MOMENT_DATE_FORMAT,
      dateA11yLabel: MOMENT_DATE_FORMAT,
      monthYearA11yLabel: MOMENT_DATE_FORMAT
    },
  };

  static countDateDifferance(startDate): number {
    const now = moment().clone().utc(true);
    const startDateWithoutZone = moment(startDate).utc(true);
    return now.diff(startDateWithoutZone, 'seconds');
  }
}

